export const CURRENCY_SYMBOL = {
    USD: '$',
    KZT: '₸',
    RUB: '₽',
    SAR: 'SAR'
}